import FanAvatarComponent from "./FanAvatarComponent";
export default FanAvatarComponent;
